<ai-knowledge-training-progress [config]="trainingProgressConfig" [shouldShowDone]="shouldShowDone" />
@if (!shouldShowTrainingProgress()) {
  @if (!isLoading()) {
    <ng-container [formGroup]="form">
      <glxy-form-field formArrayName="scrapedPages">
        <div class="pages-label-container">
          <div class="pages-label">{{ 'EDIT_KNOWLEDGE.WEBSITE_SCRAPE_CONFIG.SELECT_PAGES_TO_TRAIN' | translate }}</div>
          @if (getSuccessfullyScrapedPagesCount() > 1) {
            <div>
              <a (click)="setAllScrapedPages(true)">{{
                'EDIT_KNOWLEDGE.WEBSITE_SCRAPE_CONFIG.SELECT_ALL' | translate
              }}</a>
              |
              <a (click)="setAllScrapedPages(false)">{{
                'EDIT_KNOWLEDGE.WEBSITE_SCRAPE_CONFIG.SELECT_NONE' | translate
              }}</a
              >&nbsp;
              <span
                >(
                @if (getSuccessfullyScrapedPagesCount() === 1) {
                  {{ 'EDIT_KNOWLEDGE.WEBSITE_SCRAPE_CONFIG.PAGE_COUNT_SINGLE' | translate }}
                } @else {
                  {{
                    'EDIT_KNOWLEDGE.WEBSITE_SCRAPE_CONFIG.PAGE_COUNT'
                      | translate: { scrapedPagesCount: getSuccessfullyScrapedPagesCount() }
                  }}
                }
                )</span
              >
            </div>
          }
        </div>
        @if (getErroredScrapedPagesCount() > 0) {
          <mat-expansion-panel class="pages-error-container">
            <mat-expansion-panel-header>
              <mat-panel-title>
                <mat-icon inline="true" class="pages-error-icon">warning</mat-icon>
                {{ 'EDIT_KNOWLEDGE.WEBSITE_SCRAPE_CONFIG.UNABLE_TO_LOAD' | translate }}
              </mat-panel-title>
              <mat-panel-description>
                {{
                  'EDIT_KNOWLEDGE.WEBSITE_SCRAPE_CONFIG.PAGE_COUNT'
                    | translate: { scrapedPagesCount: getErroredScrapedPagesCount() }
                }}
              </mat-panel-description>
            </mat-expansion-panel-header>
            @for (page of getErroredScrapedPages(); track page) {
              <div class="page-error-link">
                <a [href]="page.url" target="_blank">{{ page.url }}</a>
              </div>
            }
          </mat-expansion-panel>
        }
        <div>
          @for (pageControl of scrapedPagesArray.controls; track pageControl; let i = $index) {
            @if (!websiteScrapeConfig?.scrapedPages[i]?.errorMessage) {
              <mat-checkbox [formControl]="pageControl">
                {{ websiteScrapeConfig?.scrapedPages[i]?.title }}
                <extended>{{ websiteScrapeConfig?.scrapedPages[i]?.url }}</extended>
              </mat-checkbox>
            }
          }
        </div>
      </glxy-form-field>
    </ng-container>
  } @else {
    <glxy-loading-spinner></glxy-loading-spinner>
  }
}
